import { useSelector } from "react-redux";

import { getExtensionValue } from "@medplum/core";
import { AllergyIntolerance } from "@medplum/fhirtypes";

import { Badge } from "@mantine/core";

import { get, isEmpty } from "lodash";

import { Extensions } from "@/fhir/enums/extensions";
import { RootState } from "@/store";
import { selectAllergiesList } from "@/store/slices/client-allergies";
import { AllergySeverityBadgeBorderColor, AllergySeverityBadgeColor } from "@/utils/enums";

import { ClientBadgesWrapper } from "./ClientBadgesWrapper";
import classes from "./ClientHealthSummary.module.css";
import { ClientHealthSummaryTypeEnum } from "./enums";

interface ClientAllergiesProps {
  noReportedAllergies: boolean;
  onClick?: () => void;
}

export default function ClientAllergies({ noReportedAllergies, onClick }: ClientAllergiesProps) {
  const allAllergies = useSelector<RootState, AllergyIntolerance[]>(selectAllergiesList);
  const visibleAllergies = allAllergies.filter((allergy) =>
    getExtensionValue(allergy, Extensions.DisplayAllergyOnClientSidePanel),
  );

  return (
    <ClientBadgesWrapper
      color="dark.9"
      title="Allergies"
      onClick={onClick}
      noInfo={isEmpty(visibleAllergies)}
      summaryType={ClientHealthSummaryTypeEnum.Allergy}
      noneReported={noReportedAllergies && isEmpty(visibleAllergies)}
    >
      {visibleAllergies?.map((allergy) => {
        const severity = allergy.reaction?.[0]?.severity;
        const bgColor = severity ? get(AllergySeverityBadgeColor, severity) : "gray.3";
        const borderColor = severity
          ? get(AllergySeverityBadgeBorderColor, severity)
          : "var(--mantine-color-gray-6)";
        const display = allergy.code?.coding?.[0]?.display;
        return (
          <Badge
            px="md"
            py="sm"
            tt="none"
            size="sm"
            c={"black"}
            bg={bgColor}
            key={allergy.id}
            variant="filled"
            bd={`1px solid ${borderColor}`}
            className={classes.patientBadge}
          >
            {display}
          </Badge>
        );
      })}
    </ClientBadgesWrapper>
  );
}
